"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var first_by_class_1 = require("../first-by-class");
var get_parents_1 = require("../get-parents");
function getParentWithClass(element, className) {
    return first_by_class_1.default(get_parents_1.default(element), className);
}
exports.default = getParentWithClass;
